import { render, staticRenderFns } from "./multipleChoice.vue?vue&type=template&id=443f8661&scoped=true"
import script from "./multipleChoice.vue?vue&type=script&lang=js"
export * from "./multipleChoice.vue?vue&type=script&lang=js"
import style0 from "./multipleChoice.vue?vue&type=style&index=0&id=443f8661&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443f8661",
  null
  
)

export default component.exports